import toast from "@/services/Notification";
import HTTP from "@/_helpers/http";
import { CHARTS__API } from "@/_helpers/urls";
import { CHARTS__MUTATIONS } from "../mutation-types";
import { CHARTS__ACTIONS } from "../action-types";

// State
const state = {
  profitLossChartHistories: [],
  closedTradesProfitLossChartHistories: [],
  dashboardProfitLossCharts: [],
  singleAccountProfitLossSummary: [],
  managerInvestorProfitLoss: [],
  managerInvestorBuySell: [],
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [CHARTS__MUTATIONS.SINGLEACCOUNTPROFITLOSSSUMMARY](state, data) {
    state.singleAccountProfitLossSummary = data;
  },
  [CHARTS__MUTATIONS.PROFITLOSSCHARTHISTORY](state, data) {
    state.profitLossChartHistories = data;
  },
  [CHARTS__MUTATIONS.CLOSEDTRADESPROFITLOSSCHARTHISTORY](state, data) {
    state.closedTradesProfitLossChartHistories = data;
  },
  [CHARTS__MUTATIONS.DASHBOARDPROFITLOSSCHARTHISTORY](state, data) {
    state.dashboardProfitLossCharts = data;
  },
  [CHARTS__MUTATIONS.MANAGERINVESTORPROFITLOSSCHART](state, data) {
    state.managerInvestorProfitLoss = data;
  },
  [CHARTS__MUTATIONS.MANAGERINVESTORBUYSELLCHART](state, data) {
    state.managerInvestorBuySell = data;
  },
};

// Actions
const actions = {
  async [CHARTS__ACTIONS.PROFITLOSSCHARTHISTORY]({ commit, state }, data) {
    try {
      const qParam =
        data?.time !== undefined && data?.time !== null
          ? `q=${data?.time}`
          : "q=";
      const loginParam =
        data?.account !== undefined && data?.account !== null
          ? `login=${data?.account}`
          : "login=";

      const url = `${CHARTS__API.PROFITLOSSCHARTHISTORY}?${qParam}&${loginParam}`;
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(url);
      commit(CHARTS__MUTATIONS.PROFITLOSSCHARTHISTORY, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [CHARTS__ACTIONS.CLOSEDTRADESPROFITLOSSCHARTHISTORY](
    { commit, state },
    data
  ) {
    try {
      const qParam =
        data?.time !== undefined && data?.time !== null
          ? `q=${data?.time}`
          : "q=";
      const loginParam =
        data?.account !== undefined && data?.account !== null
          ? `login=${data?.account}`
          : "login=";

      const url = `${CHARTS__API.CLOSEDTRADESPROFITLOSSCHARTHISTORY}?${qParam}&${loginParam}`;
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(url);
      commit(
        CHARTS__MUTATIONS.CLOSEDTRADESPROFITLOSSCHARTHISTORY,
        response.data
      );
    } catch (error) {
      console.log(error);
    }
  },

  async [CHARTS__ACTIONS.SINGLEACCOUNTPROFITLOSSSUMMARY](
    { commit, state },
    data
  ) {
    try {
      const qParam =
        data?.time !== undefined && data?.time !== null
          ? `duration=${data?.time}`
          : "duration=";

      const idParam =
        data?.id !== undefined && data?.id !== null ? `id=${data?.id}` : "id=";

      const url = `${CHARTS__API.SINGLEACCOUNTPROFITLOSSSUMMARY}?${qParam}&${idParam}`;
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(url);
      commit(CHARTS__MUTATIONS.SINGLEACCOUNTPROFITLOSSSUMMARY, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [CHARTS__ACTIONS.MANAGERINVESTORPROFITLOSSCHART](
    { commit, state },
    data
  ) {
    try {
      const qParam =
        data?.time !== undefined && data?.time !== null
          ? `q=${data?.time}`
          : "q=";
      const idParam =
        data?.id !== undefined && data?.id !== null ? `id=${data?.id}` : "id=";
      const symbolParam =
        data?.symbol !== undefined && data?.symbol !== null
          ? `symbol=${data?.symbol}`
          : "symbol=";

      const url = `${CHARTS__API.MANAGERINVESTORPROFITLOSSCHART}?${qParam}&${idParam}&${symbolParam}`;
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(url);
      commit(CHARTS__MUTATIONS.MANAGERINVESTORPROFITLOSSCHART, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [CHARTS__ACTIONS.MANAGERINVESTORBUYSELLCHART]({ commit, state }, data) {
    try {
      const qParam =
        data?.time !== undefined && data?.time !== null
          ? `q=${data?.time}`
          : "q=";
      const idParam =
        data?.id !== undefined && data?.id !== null ? `id=${data?.id}` : "id=";
      const buySellTypeParam =
        data?.buySellType !== undefined && data?.buySellType !== null
          ? `buySellType=${data?.buySellType}`
          : "buySellType=";

      const url = `${CHARTS__API.MANAGERINVESTORBUYSELLCHART}?${qParam}&${idParam}&${buySellTypeParam}`;
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(url);
      commit(CHARTS__MUTATIONS.MANAGERINVESTORBUYSELLCHART, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [CHARTS__ACTIONS.DASHBOARDPROFITLOSSCHARTHISTORY](
    { commit, state },
    data
  ) {
    try {
      const url = `${CHARTS__API.DASHBOARDPROFITLOSSCHARTHISTORY}`;
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(url);
      commit(CHARTS__MUTATIONS.DASHBOARDPROFITLOSSCHARTHISTORY, response.data);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
